import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { RaceInfo } from '../components/RaceInfo';
import { RacingClasses } from '../components/RacingClasses';
import { CompetitionMap } from '../components/CompetitionMap';
import { TeamSponsors } from '../components/TeamSponsors';
import { ContactForm } from '../components/ContactForm';
import { PhotoGallery } from '../components/PhotoGallery';
import { Footer } from '../components/Footer';
import { LanguageProvider } from '../context/LanguageContext';
export function HomePage() {
  return <LanguageProvider data-id="element-787">
      <div className="min-h-screen w-full bg-black" data-id="element-788">
        <Navbar data-id="element-789" />
        <main data-id="element-790">
          <HeroSection data-id="element-791" />
          <RaceInfo data-id="element-792" />
          <RacingClasses data-id="element-793" />
          <CompetitionMap data-id="element-794" />
          <TeamSponsors data-id="element-795" />
          <ContactForm data-id="element-796" />
          <PhotoGallery data-id="element-797" />
        </main>
        <Footer data-id="element-798" />
      </div>
    </LanguageProvider>;
}